import { StudentDestinationsTable } from '@features/student-destinations/components/StudentDestinationsTable'
import { Box } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/student-futures/destinations')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Student destinations',
        },
    },
})

function RouteComponent() {
    return (
        <div style={{ height: '100%' }}>
            <Box p={5} style={{ height: '100%' }}>
                <StudentDestinationsTable />
            </Box>
        </div>
    )
}
